import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { AuthService } from "../Services/auth.service";
import { CommonService } from "../Services/common.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  standalone:false,
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  constructor(private auth:AuthService,private commonService:CommonService,private _router:Router){
  }

  async ngOnInit():Promise<void> {
//     this.commonService.presentLoading();
//     this.auth.accessToken = await this.commonService.Get("token");

//     this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
//       if (data?.response?.code == 1) {
//         
//         ('data',data);
//                 await this.commonService.hideLoading();

//         // this.auth.GetDList(this.auth.accessToken,"LT").then((data:any)=>{
//         //   if (data?.response?.code == 1) {
//         //     ;
          
//         //     let IDTypelist=data?.response?.content?.list?.LT;
//         //     ('LTList',data?.response?.content?.list?.LT);
//         //     this.Tenurelist =IDTypelist.map(x=>({value:x.strCode,displayValue:x.labelAr}))
//         //     this.FromAccountlist = this.dashB.balance;
//         //     this.commonService.hideLoading();
         
//         //   }else{
//         //     
//         //     this.commonService.hideLoading();
//         //     this.commonService.ParseErrorAlert('', '', this._router, data);
         
         
//         //   }
         
//         //  })
      
//       } else {
//         await this.commonService.hideLoading();

//         this.commonService.ParseErrorAlert("", "", this._router, data);
//       }
    
  
// });
await this.commonService.presentLoading();

    this.auth.getverionObject.uniqueId = this.commonService.Guid();
    this.auth.getverionObject.parentVersion = "1.0";
    this.auth.getverionObject.version = "0.0.1";
    this.auth.getverionObject.platform = "W";
    this.auth.getverionObject.clear = false;
    ;
    this.auth.GetVersion().then((res: any) => {
      if (res?.response?.code == 1) {
        // let checkVersionData: any = JSON.parse(
        //   this.commonService.DecryptCustom(res.response.content)
        // );
        //
        // this.config.TimeOut = checkVersionData.dynamicObject.TimeOut;
        // this.config.ServerVersion = checkVersionData.version;
        // this.config.BlinkIDAndroid = checkVersionData.dynamicObject.BlinkIDAndroid;
        // this.config.BlinkIDIOS = checkVersionData.dynamicObject.BlinkIDIOS;
        // this.config.OtpResendTime = checkVersionData.dynamicObject.OtpResendTime;
        // this.config.Morning = checkVersionData.dynamicObject.Morning;
        // this.config.Evening = checkVersionData.dynamicObject.Evening;
        // this.config.Afternoon = checkVersionData.dynamicObject.Afternoon;
        // this.config.videoSecret = checkVersionData.dynamicObject.VideoSecret;
        // this.config.vidoeKey = checkVersionData.dynamicObject.VideoKey;
        // this.config.AllowedTypeArray = checkVersionData.dynamicObject.AllowedTypeDoc;
        // this.config.oecdsite = checkVersionData.dynamicObject.oecdsite;
        // this.config.ReferralCode = checkVersionData.dynamicObject.ReferralCode;
        // this.referralCode = checkVersionData.dynamicObject.ReferralCode;
        // this.config.RefCodeExpiry = checkVersionData.dynamicObject.RefCodeExpiry;

        // this.commonP.Set('AllowedDocs', this.config.AllowedTypeArray);
        this.commonService.hideLoading();
      } else {
        if (res?.name == "TimeoutError") {
          // this.translate.get(["Wewillbe", "WeRegrettheinconvenience", "Retry"]).subscribe(data => {
          //   // this.commonP.showErrorAlert(data.Wewillbe, data.WeRegrettheinconvenience, data.Retry, this._router).then((data: any) => {
          //   //   window.location.reload();
          //   // })
          // })
          this.commonService.hideLoading();
        } else {
          this.commonService.hideLoading();
          // this.commonP.ParseErrorAlert('', '', this._router, res);
        }
      }
    });

}
}
